import Header from './../../../../../Headers/HeaderForAreLoggedIn/index.vue'
import ProgressHUD from './../../../../../ProgressHUD/index.vue'
import { Helper } from './../../../../../../services'
import GoogleMap from './../../../../../GoogleMap/VueGoogleMap.vue'

export default {
  name: 'CompanyInfo',
  props: [],
  components: {
    Header,
    ProgressHUD,
    GoogleMap,
  },
  props: {
    display: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      company: {
        name: '',
        type: '',
        taxId: '',
        legalRepresentativeFullName: '',
        emailPresident: '',
        address: '',
        country: '',
        location: {
          latitude: null,
          longitude: null,
        },
        phoneManager: '',
        facebookLink: '',
        twitterLink: '',
        googleLink: '',
        linkedinLink: '',
        instagramLink: '',
      },
      countries: null,
      validationMessage: '',
    }
  },
  methods: {
    async isValid() {
      return await this.$validator.validateAll('companyForm')
    },

    getData() {
      this.company.location.latitude = this.$refs.googleMap.marker.position.lat()
      this.company.location.longitude = this.$refs.googleMap.marker.position.lng()

      this.company.country = this.$refs.selectCountry.value

      return {
        name: this.company.name,
        type: this.company.type,
        taxId: this.company.taxId,
        legalRepresentativeFullName: this.company.legalRepresentativeFullName,
        emailPresident: this.company.emailPresident,
        address: this.company.address,
        country: this.company.country,
        location: {
          latitude: this.company.location.latitude,
          longitude: this.company.location.longitude,
        },
        managerPhone: this.company.phoneManager,
        facebookLink: this.company.facebookLink,
        twitterLink: this.company.twitterLink,
        instagramLink: this.company.instagramLink,
        googleLink: this.company.googleLink,
        linkedinLink: this.company.linkedinLink,
      }
    },

    setData(company) {
      if (company) {
        this.company.name = company.name
        this.company.type = company.type
        this.company.taxId = company.taxId
        this.company.legalRepresentativeFullName =
          company.legalRepresentativeFullName
        this.company.emailPresident = company.emailPresident
        this.company.address = company.address
        this.company.country = company.country
        this.company.location.latitude = company.location.latitude
        this.company.location.longitude = company.location.longitude
        this.company.phoneManager = company.managerPhone
        this.company.facebookLink = company.facebookLink
        this.company.twitterLink = company.twitterLink
        this.company.googleLink = company.googleLink
        this.company.linkedinLink = company.linkedinLink
        this.company.instagramLink = company.instagramLink

        this.$refs.selectCountry.value = company.country

        this.$refs.googleMap.setPosition(
          company.location.latitude,
          company.location.longitude
        )
      }
    },
  },
  created() {
    this.countries = require('./../../../../../../data/country.js')
  },
}



// WEBPACK FOOTER //
// ./src/components/Account/Permissions/Roles/BaseComponents/CompanyInfo/CompanyInfo.component.js